export class ImportLocations {
  public fileId: string;
}
